import { render, staticRenderFns } from "./ComponentLoading.vue?vue&type=template&id=8607ffe2&scoped=true&"
import script from "./ComponentLoading.ts?vue&type=script&lang=ts&"
export * from "./ComponentLoading.ts?vue&type=script&lang=ts&"
import style0 from "./ComponentLoading.scss?vue&type=style&index=0&id=8607ffe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8607ffe2",
  null
  
)

export default component.exports